<script setup lang="ts">
/**
 * Pagar `noindex` untuk rute transaksional — dipasang di sini, bukan di tiap
 * halaman, karena halaman-halaman itu (`/redeem`, `/checkout`, `/app/*`) hanya
 * memanggil `useHead({ title })` dan TIDAK memanggil `pakaiSeo()`, sehingga
 * tidak memancarkan sinyal robots sama sekali.
 *
 * KENAPA META, BUKAN CUKUP HEADER: perlindungan sebelumnya hanya berupa
 * `x-robots-tag` dari `routeRules` di nuxt.config.ts, dan header itu butuh
 * server/edge untuk dieksekusi. Begitu situs disajikan sebagai berkas statis,
 * header itu tidak pernah terkirim dan halaman-halaman tersebut jadi bisa
 * diindeks. Meta di dalam HTML ikut terbawa ke berkas hasil prerender,
 * sehingga berlaku di host mana pun.
 *
 * Tiga lapis yang sekarang ada, sengaja saling menutup:
 *   1. meta di sini            -> ikut ke HTML statis, berlaku di mana saja
 *   2. `_headers`              -> lapisan HTTP di Cloudflare/Netlify
 *   3. routeRules nuxt.config  -> berlaku bila kelak disajikan dari server
 *
 * Nilai `undefined` pada rute lain penting: halaman publik menyetel robots-nya
 * sendiri lewat pakaiSeo(), dan nilai undefined tidak menghasilkan tag apa pun
 * sehingga tidak bertabrakan.
 */
const route = useRoute()
useSeoMeta({
  robots: () => (tanpaIndeks(route.path) ? 'noindex, nofollow' : undefined)
})
</script>

<template>
  <!--
    app.vue sekarang hanya kerangka tipis.
    - layout `default` = tampilan RESMI situs, tema "Liquid CoreAsia"
      (putih + gold + teal) di atas Nuxt UI v4 + Tailwind v4.
    - layout `legacy`  = tampilan LAMA (CSS tulis-tangan, tidak diubah sama
      sekali), dipakai halaman cadangan di /legacy/* sebagai pembanding.
    Styling global lama dipindah utuh ke app/assets/css/legacy.css (didaftarkan di nuxt.config.ts).
  -->
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
